import React from 'react';
import PropTypes from 'prop-types';

import { Box, Image } from 'Components/Base';
import { SPACE } from 'Components/Theme';

const Banner = ({ link, imageSrc, subjectName, onBannerClick }) => {
  const handleBannerClick = event => {
    onBannerClick(event);
  };

  return (
    <Box mx="auto" mb={SPACE.large}>
      <a href={link} target="_blank" rel="noopener noreferrer" onClick={handleBannerClick}>
        <Image
          src={imageSrc}
          style={{ margin: '0 auto', width: '100%' }}
          alt={`ซื้อคอร์ส ${subjectName} ที่ OnDemand`}
          maxWidth={780}
        />
      </a>
    </Box>
  );
};

Banner.propTypes = {
  link: PropTypes.string,
  imageSrc: PropTypes.string,
  subjectName: PropTypes.string,
  onBannerClick: PropTypes.func,
};
Banner.defaultProps = {
  link: '#',
  imageSrc: '',
  subjectName: '',
  onBannerClick: () => {},
};
export default Banner;
